var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import React, { Component } from 'react';
import { isFunction, trigger } from '@philips-internal/oswald-ui-utils';
import { Avatar, Card, ProgressBar } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import PauseImage from '../../assets/images/global/needle-pause.png';
import ArrowImage from '../../assets/images/global/needle-arrow.png';
import PlayImage from '../../assets/images/global/needle-play.png';
import './infusion-card.css';
let InfusionCard = class InfusionCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { dsItem, ieStatus, onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        dsItem,
                        ieStatus,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener,
        onMount: eventListener
    }; }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-infusion-card__indicator' },
            React.createElement("div", { className: 'c-infusion-card__indicator-color' })));
    }
    renderContent() {
        const { dsItem, ieStatus } = this.props;
        let pathPhoto = '';
        switch (ieStatus && ieStatus.toUpperCase()) {
            case 'I': {
                pathPhoto = PlayImage;
                break;
            }
            case 'INT': {
                pathPhoto = PauseImage;
                break;
            }
            case 'R': {
                pathPhoto = ArrowImage;
                break;
            }
            default: {
                break;
            }
        }
        return (React.createElement("div", { className: "c-infusion-card__avatar" },
            React.createElement(Avatar, { image: pathPhoto, title: dsItem })));
    }
    progressBarRender() {
        const { nrEtapaAtual, nrEtapas } = this.props;
        return (React.createElement(ProgressBar, { currentPart: nrEtapaAtual, leftText: `${nrEtapaAtual}/${nrEtapas}`, maxParts: nrEtapas }));
    }
    render() {
        const { nrEtapaAtual } = this.props;
        return (React.createElement(Card, { className: 'c-infusion-card', onClick: trigger(this.onClick), selectionType: SelectionType.SINGLE, uuid: generateUUID(), key: nrEtapaAtual, width: 12 },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-infusion-card__wrapper' },
                this.renderContent(),
                this.progressBarRender())));
    }
};
InfusionCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], InfusionCard);
export default InfusionCard;
//# sourceMappingURL=infusion-card.js.map